//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.div`
    position: sticky;
    top: 72px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    z-index: 100;
    width: 100%;
    background-color: var(--green-2);
    padding: 8px 10px;
    transition: 0.5s;
    &.error {
        background-color: var(--red-3);
    }
    &.notify {
        background-color: var(--light-gray-4);
    }
    &.hidden {
        opacity: 0;
        visibility: hidden;
        position: fixed;
    }
    h6 {
        margin: 0;
        color: var(--light-1);
        font-size: 12px;
        font-weight: bold;
    }
`;
export const CloseButton = styled.span`
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    border-radius: 5px;
    transition: 0.35s;
    cursor: pointer;
    &:hover {
        backdrop-filter: contrast(50%);
    }
    svg {
        fill: var(--light-1);
        width: 20px;
        height: 20px;
    }
`;